// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import configReader from '../../config/config';

const config = configReader.loadConfig();

export const useConfig = () => {
  return config;
};
